import React from 'react';
import { Input, PhoneInput, useT } from '@repo/common';

const PhoneInputBlock = ({
  value,
  isActive,
  focused,
  inputRef,
  state,
  selectedCountry,
  setSelectedCountry,
  onChange,
  onActivate,
  onDeactivate,
  onFocus,
}) => {
  const t = useT();
  const displayValue = value?.number
    ? `${value.countryCode ?? ''} ${value.number}`.trim()
    : '';

  return (
    <div className='relative min-w-[260px] w-full'>
      <div
        className={`transition-all duration-300 ${
          isActive
            ? 'opacity-0 pointer-events-none absolute inset-0'
            : 'opacity-100'
        }`}
      >
        <Input
          id='phone-placeholder'
          label={focused ? `${t('Phone', '전화번호')}*` : ''}
          placeholder=''
          value={value?.number ? displayValue : ''}
          readOnly
          hideCount
          showStatusIcon={false}
          onClick={onActivate}
          className='placeholder:opacity-0 w-full md:max-w-[380px]'
        />
        {!value?.number && !focused && (
          <span className='absolute left-4 top-[25%] text-text-placeholder pointer-events-none'>
            {t('Phone', '전화번호')}
            <span className='text-text-accent ml-0.5'>*</span>
          </span>
        )}
      </div>

      <div
        className={`transition-all duration-500 ease-in-out ${
          isActive
            ? 'opacity-100'
            : 'opacity-0 pointer-events-none absolute inset-0'
        }`}
      >
        <PhoneInput
          id='phone-input'
          ref={inputRef}
          label={focused || value?.number ? `${t('Phone', '전화번호')}*` : ''}
          value={value?.number ?? ''}
          state={state}
          hideCount
          showStatusIcon={false}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          onChange={onChange}
          onFocus={onFocus}
          onDeactivate={onDeactivate}
          className='placeholder:opacity-0 w-full'
        />
      </div>
    </div>
  );
};

export default PhoneInputBlock;
